import { ZoomOutButton } from 'components/shared';
import { DEFAULT_BRUSH_ZOOM_CONFIG } from 'config';
import { useTotalOIPutCallImpactCtx } from './useTotalOIPutCallImpactCtx';

export const TotalOIPutCallImpactZoomOutButton = () => {
  const { zoomConfig, setZoomConfig, initialData } =
    useTotalOIPutCallImpactCtx();

  return (
    <ZoomOutButton
      zoomConfig={zoomConfig}
      setZoomConfig={setZoomConfig}
      initialData={initialData}
      overrideDefault={{
        leftIdx: DEFAULT_BRUSH_ZOOM_CONFIG.leftIdx,
        rightIdx: initialData.length - 1,
      }}
    />
  );
};
